import { Mail, MessageCircle, Pencil, Phone } from "lucide-react";
import { Modal } from "./common";
import { waTarget } from "../lib/wa";
import { money } from "../lib/finance";
import { isPendingRequest, WaitBadge } from "./NewRequestsCounter";

const trd = (s) => (s ? s.slice(0, 10).split("-").reverse().join(".") : "");

export function QuoteRequestDetail({ quote: q, onEdit, onClose }) {
  const wa = waTarget(q.customerPhone);
  const rows = [["Branş", q.branch], ["Plaka", q.plate], ["Ruhsat seri no", q.ruhsatSeriNo], ["T.C. Kimlik No", q.tcKimlik], ["Doğum tarihi", trd(q.birthDate)],
    ["Durum", q.status], ["Geliş tarihi", q.createdAt ? new Date(q.createdAt).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }) : ""]].filter(([, v]) => v);
  return (
    <Modal title={q.customerName || "Teklif talebi"} onClose={onClose}>
      <div className="qreq" data-testid="quote-request-detail">
        <span className={`badge ${q.source === "online_link" ? "badge-blue" : "badge-slate"}`}>{q.source === "online_link" ? "Online / QR teklif talebi" : "Manuel teklif"}</span>
        {isPendingRequest(q) && <WaitBadge q={q} />}
        <div className="qreq-contact">
          {q.customerPhone && <a className="contact-chip" href={`tel:${q.customerPhone}`} data-testid="qreq-call"><Phone size={12} /> {q.customerPhone}</a>}
          {wa && <a className="contact-chip whatsapp" href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" data-testid="qreq-wa"><MessageCircle size={12} /> WhatsApp</a>}
          {q.customerEmail && <a className="contact-chip" href={`mailto:${q.customerEmail}`} data-testid="qreq-email"><Mail size={12} /> {q.customerEmail}</a>}
        </div>
        <dl className="qcheck-rows">{rows.map(([l, v]) => <div key={l}><dt>{l}</dt><dd>{v}</dd></div>)}</dl>
        {(q.note || "").trim() && (<><h4>Talep detayları ve notlar</h4><p className="qreq-note" data-testid="qreq-note">{q.note}</p></>)}
        {q.customerChoiceNote && (<><h4>Müşteri notu</h4><p className="qreq-note">{q.customerChoiceNote}</p></>)}
        {q.offers?.length > 0 && (<><h4>Şirket teklifleri</h4><ul className="qcheck-others">{q.offers.map((o) => <li key={o.id}><span>{o.company}{o.quoteNo ? ` · ${o.quoteNo}` : ""}</span><b>{o.premium ? money(o.premium) : "—"}</b></li>)}</ul></>)}
        <div className="modal-actions">
          <button type="button" className="outline-button" onClick={onClose} data-testid="qreq-close">Kapat</button>
          <button type="button" className="primary-button" onClick={() => { onClose(); onEdit(q); }} data-testid="qreq-edit"><Pencil size={14} /> Teklif hazırla / düzenle</button>
        </div>
      </div>
    </Modal>
  );
}
